<template>
  <div class="journal-base">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "journalBase",
};
</script>
